import Skeleton from 'react-loading-skeleton';

export const ModalTable = ({
  isLoading,
  tableHeaderRow,
  isEmpty,
  children,
}: {
  isLoading: boolean;
  tableHeaderRow: React.ReactNode;
  isEmpty: boolean;
  children: React.ReactNode;
}) => {
  if (isLoading) {
    return <Skeleton count={5} />;
  }

  return (
    <table className="w-full border-separate border-spacing-0 rounded-s border-l border-r border-t border-secondary-80 text-m [&_:is(td,th):first-child]:rounded-tl-s [&_:is(td,th):last-child]:rounded-tr-s [&_:is(td,th)]:border-b [&_:is(td,th)]:border-secondary-80 max-800:[&_:is(td,th)]:p-s [&_td]:p-l max-800:[&_td]:text-xs [&_th]:bg-secondary-97 [&_th]:p-l [&_th]:text-left [&_th]:text-xs [&_th]:uppercase [&_th]:text-structure-40">
      <thead>{tableHeaderRow}</thead>
      <tbody>
        {isEmpty ? (
          <tr>
            <td colSpan={4}>No data found.</td>
          </tr>
        ) : null}
        {!isEmpty ? children : null}
      </tbody>
    </table>
  );
};
